import AcademicInfoGroups from './component';
import _routes from './routes';

export default AcademicInfoGroups;

export const routes = _routes;



// WEBPACK FOOTER //
// ./containers/UserDashboard/AcademicInfo/AcademicInfoGroups/index.js